/* ── DANDI — Core JS ──
   Scroll animations, Quick Shop stub, utilities
*/

// ── Reveal on scroll ──
(function initReveal() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(el => {
      if (el.isIntersecting) {
        el.target.classList.add('is-visible');
        observer.unobserve(el.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('[data-dandi-reveal]').forEach(el => observer.observe(el));

  // Re-run on dynamic content
  document.addEventListener('dandi:section:load', () => {
    document.querySelectorAll('[data-dandi-reveal]:not(.is-visible)').forEach(el => observer.observe(el));
  });
})();

// ── Quick Shop (stub — opens product page on mobile, drawer on desktop) ──
function dandiQuickShop(productUrl) {
  if (window.innerWidth < 750) {
    window.location.href = productUrl;
    return;
  }
  // Basic fetch preview — replace with full drawer implementation if needed
  window.location.href = productUrl;
}

// ── Smooth number counter animation ──
function dandiCounter(el, target, duration) {
  let start = 0;
  const step = timestamp => {
    if (!start) start = timestamp;
    const progress = Math.min((timestamp - start) / duration, 1);
    el.textContent = Math.floor(progress * target).toLocaleString();
    if (progress < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
}
